<template>
  <div class="comment">
    <div class="comment-title">{{ `评论 ${comments ? comments.length : '0'}` }}</div>
    <a-spin :spinning="spinning">
      <a-textarea
        class="comment-edit"
        v-model="commentEdit"
        placeholder="留下您的评论"
        :auto-size="{ minRows: 3, maxRows: 5 }"
        :maxlength="500"
      />
      <div style="display:flex;justify-content:flex-end">
        <a-button class="comment-publish" type="primary" :disabled="commentEdit === ''" @click="onComment">发布</a-button>
      </div>
      
      <div class="comment-content" v-for="item in comments" :key="item.id">
        <comment-row 
          :item="item" 
          @click="openComment" 
          @comment="()=>{ spinning = true }"
          @finish="finishComment"
          @delete="delComment"
          :showComment="selectCommentId === item.id" 
        />
        <div v-if="item.replyList.length !== 0" class="comment-content-second">
          <div v-for="subItem in item.replyList" :key="subItem.id">
            <comment-row 
              :item="subItem" 
              @click="openComment" 
              @comment="()=>{ spinning = true }"
              @finish="finishComment"
              @delete="delComment"
              :showComment="selectCommentId === subItem.id" />
          </div>
        </div>
      </div>
    </a-spin>
    <!-- <load-more-btn v-model="loading" @loadMore="queryList()"></load-more-btn> -->
  </div>
</template>

<script>
import CommentRow from './CommentRow.vue'
import { getComments, addComment, deleteComment } from '@/utils/api.js'

export default {
  props: {
    articleItem: {type: Object, default:()=>{}}
  },
  components: {
    CommentRow
  },
  data() {
    return {
      commentEdit: '',
      selectCommentId: '',
      comments: [],
      loading: false,
      spinning: false
    }
  },
  created() {
    this.queryComments()
  },
  computed: {
    postsId() {
      return this.$route.params.id
    },
    // 是否登录用户
    isLogin() {
      return !!this.$store.state.userInfo.uid
    },
  },
  methods: {
    queryComments() {
      getComments(this.postsId).then(res => {
        this.spinning = false
        if (res.code === 0) {
          this.comments = res.data
        } else {
          this.$message.error('获取评论失败')
        }
      })
    },
    openComment(id) {
      this.selectCommentId === id ? this.selectCommentId  = '' : this.selectCommentId = id
    },
    finishComment() {
      this.queryComments()
      this.selectCommentId = ''
    },
    delComment(id) {
      this.spinning = true
      deleteComment(id).then(res => {
        if (res.code === 0) {
          this.queryComments()
          this.$message.success('删除成功')
        } else {
          this.$message.error('删除失败')
        }
      })
    },
    queryList() {
      console.log('comments',this.comments)
    },
    exchangeComment(orginalComment,commentId) {
      if (orginalComment.replyList) {
        return {
          ...orginalComment,
          commentId: commentId,
        }
      } else {
        return {
          ...orginalComment
        }
      }
    },
    onComment() {
      // 未登录，跳转登录页
      if(!this.isLogin) {
        window.location.href = `/auth/login?fromUrl=https%3A%2F%2F${window.location.host}%2Fporos-community%2Findex`
        return
      }
      this.spinning = true
      const params = {
        content: this.commentEdit,
        postsId: this.postsId,
        replyUser: this.articleItem.authorInfo.userId
      }
      addComment(params).then(res => {
        if (res.code === 0) {
          this.commentEdit = ''
          this.$message.success('评论成功')
          this.queryComments()
        } else {
          this.spinning = false
          this.$message.error('评论失败')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.comment {
  padding: 20px;
  &-title {
    font-size: 14px;
    color: rgba(4,12,44,0.85);
    letter-spacing: 0;
    line-height: 22px;
    font-weight: 500;
  }
  &-edit {
    margin-top: 10px;
  }
  &-publish {
    margin-top: 10px;
    padding: 0 10px;
  }
  &-content {
    margin-top: 20px;
    &-second {
      margin: 10px 0;
      padding: 20px;
      margin-left:34px;
      background: #F7F7F8;
    }
  }
}
</style>